var React = require('react');

function Face (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M13.5026 0.00478553L10.3845 0C6.88145 0 4.6176 2.22168 4.6176 5.66033V8.27012H1.48248C1.21157 8.27012 0.992188 8.48021 0.992188 8.73934V12.5206C0.992188 12.7798 1.21182 12.9896 1.48248 12.9896H4.6176V22.531C4.6176 22.7902 4.83698 23 5.10789 23H9.19833C9.46924 23 9.68862 22.7899 9.68862 22.531V12.9896H13.3543C13.6252 12.9896 13.8446 12.7798 13.8446 12.5206L13.8461 8.73934C13.8461 8.61492 13.7943 8.49576 13.7025 8.40771C13.6107 8.31965 13.4856 8.27012 13.3556 8.27012H9.68862V6.05777C9.68862 4.99442 9.95353 4.45462 11.4016 4.45462L13.5021 4.4539C13.7728 4.4539 13.9922 4.24381 13.9922 3.98491V0.473768C13.9922 0.21511 13.7731 0.00526409 13.5026 0.00478553Z","fill":"#0EE9C4"}));
}

Face.defaultProps = {"width":"14","height":"23","viewBox":"0 0 14 23","fill":"none"};

module.exports = Face;

Face.default = Face;
